import { getAssigneeRpc } from '../../../__generated__/chirp/com/hubspot/cv/assignments/rpc/AssigneeService';
import { chirpClient } from '../../shared/utils/chirp-client';
export const fetchAssignee = ({
  genericChannelId,
  inboxId,
  objectTypeId,
  userId
}) => chirpClient.call(getAssigneeRpc, {
  request: {
    genericChannelId,
    inboxId,
    objectTypeId,
    userId
  }
});